<template>
  <div class='mt-1'>
    <b-modal
      ref='importTermsOfUse'
      id='importTermsOfUse'
      hide-footer
      hide-header
      header-bg-variant='info'
      header-text-variant='light'
      size='lg'
      @show='showModal()'
      :no-close-on-esc='loading'
      :no-close-on-backdrop='loading'
    >
      <b-overlay
        :show='loading'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-100'
        style='min-height: 150px'
      >
        <section class='modal-font-family'>
          <section class='d-flex justify-content-between align-items-start w-100 mb-3'>
            <section>
              <p class='title'>Importar informações</p>
              <p class='sub-title'>
                Selecione um produto e as informações que gostaria de importar para ele.
              </p>
            </section>
            <section>
              <b-icon
                style='margin-top: -8px'
                @click='closeModal()'
                class='cursor-pointer'
                font-scale='2.2'
                icon='x'
                color='#022245'
              >
              </b-icon>
            </section>
          </section>

          <hr />

          <section style='max-height: 320px; overflow-y: auto; padding-right: 5px;'>
            <section
              v-if='!sourceTree || sourceTree.length === 0'
              class='text-center py-3'
            >
              <span class='empty-text'>
                Não há outros produtos cadastrados na empresa para importar as condições de uso.
              </span>
            </section>

            <section
              v-for='sector in sourceTree'
              :key='sector.id'
              class='mb-2'
            >
              <p class='sector-name mb-1'>Setor: {{ sector.name }}</p>

              <section
                v-for='cargo in sector.cargos'
                :key='cargo.id'
                class='ml-2 mb-1'
              >
                <button
                  class='cargo-toggle d-flex align-items-center'
                  @click='toggleCargo(cargo.id)'
                >
                  <b-icon
                    :icon="isCargoExpanded(cargo.id) ? 'chevron-down' : 'chevron-right'"
                    class='mr-1'
                    font-scale='0.9'
                  ></b-icon>
                  <span class='cargo-name'>Cargo: {{ cargo.name }}</span>
                </button>

                <section v-if='isCargoExpanded(cargo.id)' class='ml-4'>
                  <b-form-checkbox
                    v-for='(product, productIndex) in cargo.products'
                    :key='`${product._id}_${productIndex}`'
                    class='product-option'
                    :checked='selectedSourceId === product._id'
                    :disabled='!!selectedSourceId && selectedSourceId !== product._id'
                    @change='selectSource(product)'
                  >
                    <span class='product-name'>Produto: {{ product.name }}</span>
                  </b-form-checkbox>
                </section>
              </section>
            </section>
          </section>

          <hr />

          <section class='mt-2'>
            <section
              v-for='option in options'
              :key='option.key'
              class='d-flex align-items-center justify-content-between option-row'
            >
              <section class='d-flex align-items-center'>
                <span class='option-icon mr-3 d-inline-flex align-items-center justify-content-center'>
                  <img
                    v-if="option.key === 'permanentExhibition'"
                    :src="require('@/assets/images/exposicaoPermanenteAzul.svg')"
                    alt='Exposição permanente'
                  />
                  <svg
                    v-else-if="option.key === 'dailyUse'"
                    width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M22.1492 9.65625H16.1492C16.0461 9.65625 15.9617 9.74062 15.9617 9.84375V10.9688C15.9617 11.0719 16.0461 11.1562 16.1492 11.1562H22.1492C22.2523 11.1562 22.3367 11.0719 22.3367 10.9688V9.84375C22.3367 9.74062 22.2523 9.65625 22.1492 9.65625ZM19.0086 12.8438H16.1492C16.0461 12.8438 15.9617 12.9281 15.9617 13.0312V14.1562C15.9617 14.2594 16.0461 14.3438 16.1492 14.3438H19.0086C19.1117 14.3438 19.1961 14.2594 19.1961 14.1562V13.0312C19.1961 12.9281 19.1117 12.8438 19.0086 12.8438ZM11.1875 7.55859H10.1727C10.0273 7.55859 9.91016 7.67578 9.91016 7.82109V13.6336C9.91016 13.718 9.95 13.7953 10.018 13.8445L13.5078 16.3898C13.625 16.4742 13.7891 16.4508 13.8734 16.3336L14.4758 15.5109V15.5086C14.5602 15.3914 14.5344 15.2273 14.4172 15.143L11.4477 12.9961V7.82109C11.45 7.67578 11.3305 7.55859 11.1875 7.55859Z'
                      fill='#022245' />
                    <path
                      d='M18.8625 15.7945H17.5078C17.3766 15.7945 17.2524 15.8625 17.182 15.975C16.8844 16.4461 16.5375 16.882 16.1391 17.2804C15.4524 17.9671 14.6531 18.5062 13.7649 18.8812C12.8438 19.2703 11.8664 19.4671 10.8586 19.4671C9.84845 19.4671 8.87111 19.2703 7.95236 18.8812C7.06408 18.5062 6.26486 17.9671 5.57814 17.2804C4.89142 16.5937 4.35236 15.7945 3.97736 14.9062C3.5883 13.9875 3.39142 13.0101 3.39142 12C3.39142 10.9898 3.5883 10.0148 3.97736 9.09371C4.35236 8.20543 4.89142 7.40621 5.57814 6.71949C6.26486 6.03277 7.06408 5.49371 7.95236 5.11871C8.87111 4.72965 9.8508 4.53277 10.8586 4.53277C11.8688 4.53277 12.8461 4.72965 13.7649 5.11871C14.6531 5.49371 15.4524 6.03277 16.1391 6.71949C16.5375 7.11793 16.8844 7.55386 17.182 8.02496C17.2524 8.13746 17.3766 8.20543 17.5078 8.20543H18.8625C19.0242 8.20543 19.1274 8.03668 19.0547 7.89371C17.5266 4.85386 14.4281 2.87808 10.9688 2.83824C5.90392 2.77496 1.69689 6.92105 1.68752 11.9812C1.67814 17.0507 5.78673 21.164 10.8563 21.164C14.3602 21.164 17.5102 19.1812 19.0547 16.1062C19.1274 15.9632 19.0219 15.7945 18.8625 15.7945Z'
                      fill='#022245' />
                  </svg>
                  <img
                    v-else-if="option.key === 'ventilation'"
                    :src="require('@/assets/images/condicaoVentilacaoAzul.svg')"
                    alt='Condição de ventilação'
                  />
                  <svg
                    v-else-if="option.key === 'temperature'"
                    width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M22.5 13.5H18C17.6023 13.4996 17.221 13.3414 16.9398 13.0602C16.6586 12.779 16.5004 12.3977 16.5 12V4.5C16.5004 4.1023 16.6586 3.721 16.9398 3.43978C17.221 3.15856 17.6023 3.0004 18 3H22.5V4.5H18V12H22.5V13.5Z'
                      fill='#022245' />
                    <path
                      d='M13.5 4.5C14.3284 4.5 15 3.82843 15 3C15 2.17157 14.3284 1.5 13.5 1.5C12.6716 1.5 12 2.17157 12 3C12 3.82843 12.6716 4.5 13.5 4.5Z'
                      fill='#022245' />
                    <path
                      d='M7.50001 15.138V9H6V15.138C5.49959 15.3149 5.07784 15.6631 4.80928 16.1209C4.54072 16.5787 4.44265 17.1167 4.53241 17.6398C4.62216 18.1629 4.89396 18.6375 5.29976 18.9796C5.70556 19.3217 6.21924 19.5093 6.75 19.5093C7.28077 19.5093 7.79445 19.3217 8.20025 18.9796C8.60605 18.6375 8.87785 18.1629 8.9676 17.6398C9.05736 17.1167 8.95929 16.5787 8.69073 16.1209C8.42217 15.6631 8.00042 15.3149 7.50001 15.138Z'
                      fill='#022245' />
                    <path
                      d='M6.75065 22.5C5.71713 22.5012 4.70631 22.1969 3.84511 21.6255C2.98391 21.0541 2.31072 20.241 1.91009 19.2883C1.50945 18.3356 1.39923 17.2858 1.59325 16.2706C1.78728 15.2555 2.27691 14.3203 3.00065 13.5825V5.25C3.00065 4.25544 3.39574 3.30161 4.099 2.59835C4.80226 1.89509 5.75609 1.5 6.75065 1.5C7.74521 1.5 8.69904 1.89509 9.4023 2.59835C10.1056 3.30161 10.5007 4.25544 10.5007 5.25V13.5825C11.2244 14.3203 11.714 15.2555 11.9081 16.2706C12.1021 17.2858 11.9919 18.3356 11.5912 19.2883C11.1906 20.241 10.5174 21.0541 9.6562 21.6255C8.795 22.1969 7.78417 22.5012 6.75065 22.5ZM6.75065 3C6.1541 3.0006 5.58215 3.23784 5.16032 3.65967C4.73849 4.0815 4.50125 4.65345 4.50065 5.25V14.2373L4.25165 14.4615C3.68531 14.9677 3.28604 15.6339 3.10669 16.372C2.92734 17.1101 2.97636 17.8853 3.24727 18.5949C3.51818 19.3046 3.9982 19.9152 4.6238 20.346C5.24939 20.7768 5.99107 21.0075 6.75065 21.0075C7.51024 21.0075 8.25191 20.7768 8.87751 20.346C9.50311 19.9152 9.98313 19.3046 10.254 18.5949C10.5249 17.8853 10.574 17.1101 10.3946 16.372C10.2153 15.6339 9.81599 14.9677 9.24965 14.4615L9.00065 14.2373V5.25C9.00006 4.65345 8.76281 4.0815 8.34098 3.65967C7.91916 3.23784 7.34721 3.0006 6.75065 3Z'
                      fill='#022245' />
                  </svg>
                </span>
                <span class='option-label'>{{ option.label }}</span>
              </section>

              <b-form-checkbox
                v-model='selectedOptions[option.key]'
                switch
                size='lg'
              ></b-form-checkbox>
            </section>
          </section>

          <section class='d-flex justify-content-between mt-4'>
            <base-button
              class='w-25 mr-3 btn-cancel'
              @click='closeModal()'
            >
              <span>Cancelar</span>
            </base-button>

            <base-button
              :disabled='disabled'
              class='w-75 btn-add d-flex align-items-center justify-content-center'
              @click='importInformations()'
            >
              <span class='mr-2'>Finalizar compartilhamento</span>
            </base-button>
          </section>
        </section>

        <template v-slot:overlay>
          <div class='text-center loading-spinner'>
            <b-spinner
              style='width: 2rem; height: 2rem'
              variant='primary'
              label='Large Spinner'
            ></b-spinner>
            <h6 class='text-primary'>Importando condições de uso...</h6>
          </div>
        </template>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ImportTermsOfUse',
  components: {},
  props: {
    targetProduct: {
      type: Object,
      required: false,
      default: null
    },
    companyLegalConsultation: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      selectedSourceId: null,
      expandedCargos: {},
      selectedOptions: {
        permanentExhibition: true,
        dailyUse: true,
        ventilation: true,
        temperature: true
      },
      options: [
        { key: 'permanentExhibition', label: 'Exposição permanente' },
        { key: 'dailyUse', label: 'Utilização diária' },
        { key: 'ventilation', label: 'Condição de ventilação' },
        { key: 'temperature', label: 'Temperatura' }
      ]
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    disabled() {
      return !this.selectedSourceId || !Object.values(this.selectedOptions).some((value) => value)
    },
    sourceTree() {
      const tree = []
      const company = this.companyLegalConsultation
      if (!company || !company.units) {
        return tree
      }
      const units = company.units || []
      units.forEach((unit) => {
        const sectors = unit.sectors || []
        sectors.forEach((sector) => {
          const cargos = []
          const sectorRoles = sector.sectorRoles || []
          sectorRoles.forEach((sectorRole) => {
            const role = sectorRole.role || {}
            const products = (role.roleProductsLegalConsultation || [])
              .filter((roleProduct) => {
                const product = roleProduct.product
                if (!product || !product._id) {
                  return false
                }
                const targetId = this.targetProduct ? this.targetProduct._id : null
                if (targetId && product._id === targetId) {
                  return false
                }
                const hasTermsOfUse = !!(product.termsofuses && product.termsofuses._id)
                const hasPermanentExhibition = !!(product.permanentExhibition && product.permanentExhibition._id)
                return hasTermsOfUse && hasPermanentExhibition
              })
              .map((roleProduct) => roleProduct.product)
            if (products.length > 0) {
              cargos.push({ id: sectorRole._id, name: role.name, products })
            }
          })
          if (cargos.length > 0) {
            tree.push({ id: sector._id, name: sector.name, cargos })
          }
        })
      })
      return tree
    }
  },
  methods: {
    ...mapActions('termsOfUse', {
      handleImport: 'handleImport'
    }),
    showModal() {
      this.loading = false
      this.selectedSourceId = null
      this.selectedOptions = {
        permanentExhibition: true,
        dailyUse: true,
        ventilation: true,
        temperature: true
      }
      this.expandedCargos = {}
    },
    toggleCargo(cargoId) {
      this.$set(this.expandedCargos, cargoId, !this.isCargoExpanded(cargoId))
    },
    isCargoExpanded(cargoId) {
      return this.expandedCargos[cargoId] !== false
    },
    selectSource(product) {
      this.selectedSourceId = this.selectedSourceId === product._id ? null : product._id
    },
    async importInformations() {
      try {
        if (this.disabled) {
          return
        }
        this.loading = true
        const payload = {
          userId: this.user.id,
          sourceProductHierarchyId: this.selectedSourceId,
          targetProductLegalConsultationId: this.targetProduct.productLegalConsultationId,
          targetProductHierarchyId: this.targetProduct._id,
          options: this.selectedOptions
        }
        const { data, status } = await this.handleImport(payload)
        this.loading = false
        let message = data.message
        let variant = 'success'
        if (status !== 200) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.closeModal()
        this.$emit('update')
      } catch (e) {
        this.loading = false
        this.$bvToast.toast('Não foi possível importar as condições de uso, verifique os dados e tente novamente.', {
          title: 'Atenção',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 10000
        })
        this.closeModal()
      }
    },
    closeModal() {
      if (this.loading) {
        return
      }
      this.$bvModal.hide('importTermsOfUse')
    }
  }
}
</script>
<style lang='scss' scoped>
.title {
  font-size: 22px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: var(--navy-blue);
  margin: 0;
}

.sub-title {
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  color: #808080;
  margin-top: 10px;
}

.empty-text {
  font-size: 16px;
  color: #808080;
}

.sector-name {
  font-size: 18px;
  font-weight: 700;
  color: var(--navy-blue);
}

.cargo-toggle {
  background: transparent;
  border: none;
  padding: 2px 0;
  cursor: pointer;

  .cargo-name {
    font-size: 17px;
    font-weight: 700;
    color: var(--navy-blue);
  }
}

.product-option {
  margin: 6px 0;

  .product-name {
    font-size: 16px;
    font-weight: 400;
    color: #262626;
  }
}

.option-row {
  padding: 10px 4px;
  border-bottom: 1px solid #F0F0F0;

  .option-icon {
    width: 24px;

    img,
    svg {
      width: 22px;
      height: 22px;
      display: block;
    }
  }

  .option-label {
    font-size: 17px;
    font-weight: 600;
    color: var(--navy-blue);
  }
}

.btn-cancel {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}
</style>
